<template>
  <div class="messages-wrapper">
    <div class="messages section">
      <div class="container">
        <p class="section-title has-text-info">Ogłoszenia dla użytkowników</p>
      </div>
      <div class="content">
        <div class="container">
          <div class="columns">
            <div class="column is-4">
              <ul class="messages-list fa-ul">
                <li
                  class="messages-list__item is-unselectable"
                  v-for="message in formattedMessages"
                  :key="message.id"
                  @click="$emit('click-message', { message })"
                >
                  <icon name="fa-angle-right" class="fa-li has-text-primary" />
                  {{ message.title }}
                </li>
              </ul>
              <router-link
                to="/messages"
                class="button is-primary is-outlined is-fullwidth"
                @click.native="$immediatelyScrollToTop"
              >
                <icon name="fa-bullhorn" />
                <span>Wszystkie ogłoszenia</span>
              </router-link>
            </div>
            <div class="column is-8">
              <div class="message-wrapper">
                <div class="placeholder is-hidden-mobile is-unselectable">
                  <img src="../../assets/img/messages.svg" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { prettyDate } from "%utils/date";
import { Icon } from "%helpers";

export default {
  name: "messages",

  components: {
    Icon
  },

  props: {
    messages: Array
  },

  computed: {
    formattedMessages() {
      return this.messages.map(message => ({
        ...message,
        date: message.date ? prettyDate(message.date) : ""
      }));
    }
  }
};
</script>

<style lang="scss" scoped>
.messages-wrapper {
  position: relative;
  top: -5rem;
}

.messages {
  margin-top: 0;
  padding-top: 0;
}

.messages-list {
  margin-bottom: 2rem;

  &__item {
    cursor: pointer;
    font-family: $family-sans-serif-condensed;
    font-weight: 500;
    padding: 1rem 0;
    color: $grey;

    &:hover {
      color: $primary;
    }
  }
}

.button {
  display: flex;
  margin: 0 auto;
  max-width: 20rem;
}

.placeholder {
  padding: 0 5rem;

  @include desktop {
    padding: 0 10rem;
  }
}
</style>
